import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    marginLeft: theme.spacing.space16,
    "& div.slick-list div.slick-track div.slick-slide": {
      marginRight: theme.spacing.space16,
    },
  },
  contentImage: {
    position: "relative",
    width: 335,
    height: 130,
    objectFit: "cover",
    borderRadius: theme.radius.medium,
  },
  dots: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: theme.spacing.space8,
    marginTop: theme.spacing.space8,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: theme.radius.button,
    transition: "width 0.5s",
    background: theme.colors.background6,
    "&.active": {
      width: 20,
      background: theme.colors.primary,
    },
  },
}));
